import { SignableDocument } from "../config/levelThreeSigning";
import { _axios } from "./axios";

type DscSigningLogEntry = {
  /** The application's database id. */
  applicationId: number | string;
  document: SignableDocument;
  /** The name on the USB token, as the signer program read it. */
  signerName: string;
  /** The kind of token that was chosen, e.g. "ePass 2003 Auto". */
  tokenName: string;
};

/**
 * Tells the backend that a document was signed with a USB token, so the
 * signing is written to the application's Audit History. The signing happens
 * on the officer's computer, and this call is how the server learns of it.
 */
export function logDscSigning(entry: DscSigningLogEntry) {
  return _axios.post("/dsc-signing-log", entry);
}

/**
 * Reports one call to the signer program - what was sent and what came back -
 * to the backend's DSC trace. It is for following a signing from the server
 * and must never get in the officer's way, so a failure here is ignored.
 */
export function traceDscCall(entry: Record<string, unknown>) {
  _axios
    .post("/dsc-signing-log/trace", { ...entry, page: window.location.pathname })
    .catch(() => undefined);
}
